import { type KeyboardEvent, type ReactNode } from 'react';
import type { SearchableColumn, SearchOption } from './types';
import s from './grid-search.module.scss';

interface ValueDropdownProps {
    options: SearchOption[];
    pendingColumn?: SearchableColumn;
    onSelect: (option: SearchOption) => void;
    onKeyDown: (
        e: KeyboardEvent<HTMLButtonElement>,
        option: SearchOption,
    ) => void;
}

export function ValueDropdown({
    options,
    pendingColumn,
    onSelect,
    onKeyDown,
}: ValueDropdownProps): ReactNode {
    return (
        <div className={s.dropdown} role="listbox">
            {options.map((option) => (
                <button
                    key={option.value}
                    type="button"
                    className={s.dropdownItem}
                    role="option"
                    aria-selected={false}
                    onMouseDown={(e) => {
                        e.preventDefault();
                        onSelect(option);
                    }}
                    onKeyDown={(e) => {
                        onKeyDown(e, option);
                    }}
                >
                    {pendingColumn?.optionRenderer
                        ? pendingColumn.optionRenderer(option.value)
                        : option.label}
                </button>
            ))}
        </div>
    );
}
